export const ADD_DUPE_EXT_VEHICLE = 'ADD_DUPE_EXT_VEHICLE';
export const REMOVE_DUPE_EXT_VEHICLE = 'REMOVE_DUPE_EXT_VEHICLE';
export const CLEAR_DUPE_EXT_VEHICLE = 'CLEAR_DUPE_EXT_VEHICLE';
